import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PublicFolderView from './components/PublicFolderView';
import reportWebVitals from './reportWebVitals';

// A ?publicFolder=<token> link opens a shared folder read-only, without any
// login, so it bypasses the chat app entirely. Optional &folder=, &file=,
// &gallery=1, and &subfolders=1 jump into a folder, open a media popup, and
// include nested folder files in that view.
const publicFolderParams = new URLSearchParams(window.location.search);
const publicFolderToken = publicFolderParams.get('publicFolder');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {publicFolderToken ? (
      <PublicFolderView
        shareToken={publicFolderToken}
        initialFolderId={publicFolderParams.get('folder')}
        initialFileKeys={publicFolderParams.getAll('file')}
        openGallery={publicFolderParams.get('gallery') === '1'}
        initialShowSubfolders={publicFolderParams.get('subfolders') === '1'}
      />
    ) : (
      <App />
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
